<template>
<div>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <img class="img-fluid" src="../../../public/logo.png" width="50px" height="50px" alt="КЦОКО">
    <router-link to="/" class='navbar-brand d-none d-lg-block'>ГУ КЦОКО Забайкальского края</router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
    <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
           <router-link to="/files/edu" class='nav-link'><i class="fas fa-school"></i>  Образование</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/files/culture" class='nav-link'><i class="fas fa-graduation-cap"></i>  Культура</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="!user.login">
          <div class="nav-link" style='cursor: pointer;' @click="login=!login">
            <i class="fas fa-lock"></i> Войти
          </div>
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.cabinet">
          <router-link to="/cabinet" class='nav-link'><i class="fas fa-briefcase"></i>  Личные данные</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.stages">
          <router-link to="/stages" class='nav-link'><i class="far fa-calendar"></i>  Этапы</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.stagesmod">
          <router-link to="/modstages" class='nav-link'><i class="far fa-calendar"></i>  Изменение этапов</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.edu">
          <router-link to="/edu" class='nav-link'><i class="far fa-calendar"></i>  Исследования</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.admin">
          <router-link to="/fotocheck" class='nav-link'><i class="far fa-calendar"></i>  Образование анкеты</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.admin">
          <router-link to="/fotocheckc" class='nav-link'><i class="far fa-calendar"></i>  Культура анкеты</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login && user.option.admin">
          <router-link to="/newsadmin" class='nav-link'><i class="fas fa-newspaper"></i>  Новости</router-link> 
        </li>
        <li class="nav-item form-inline" v-if="user.login" @click='razlogin();'>
          <div class='nav-link' style='cursor: pointer;'><i class="fas fa-door-open"></i> Выход</div>
        </li>
      </ul>
    </div>
    <div class="form-inline" v-show="login">
      <input type='text' class='form-control col-5' placeholder="Логин" v-model="info.login" />  
      <input type='password' class='form-control col-5' placeholder="Пароль" v-model="info.pass" />
      <input type='button' class='btn btn-outline-success btn-sm' value='Войти' @click="loginPush();" />
      </div>
  </nav>
  </div>
</template>
<script>

import axios from 'axios';

export default {
  methods:{
    razlogin: function(){
      axios({
        'url': 'http://eduqa.egechita.ru/back/exit', 
        withCredentials: true
      }).then((response)=>{
        this.$root.getUser();
      }); 
    },
    loginPush: function(){
      axios({
        method: 'post', 
        'url': 'http://eduqa.egechita.ru/back/login', 
        withCredentials: true,
        data: this.info
      }).then((response)=>{
        this.$root.getUser();
        this.login = false;
      });      
    }
  },
  props: ['user'],
  data(){
    return {
      login: 0,
      info: {
        login: "",
        pass: ""
      }
    };
  }

};
</script>
